import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-paspoort',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconPaspoort {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m11.97 10.85 1.14.22-.44 1.91-1.55.83.57-1.05-.47-.95c-.03-.07.08-.8.08-.8l-1.41-.5-1.88 5v1.09l.92.58-.92 1.03-1.38-.52-.46 1.03L8.01 20l1.38-1h1.84l.46.75.3.11V25h-5c-.55 0-1 .44-1 1 0 .55.45 1 1 1h5v6H2.04C.91 33 0 32.09 0 30.96V6.29h.02V2.94C.02 1.32 1.34 0 2.96 0h15.02c1.3 0 2.39.84 2.8 2H3c-.56 0-1 .44-1 1s.44 1 1 1h17.7c.61 0 1.19.24 1.62.67.44.43.68 1.01.68 1.63v10.71h-8l1-2h1v-2h-1v-1h.94l.47-3h-.94l-.47-1-2.99.32-.85.91-.19 1.62ZM36 21.53v11.94c0 1.4-1.13 2.53-2.53 2.53H16.54c-1.4 0-2.54-1.14-2.54-2.54V21.04c0-1.12.91-2.03 2.03-2.03h7.96v2c0 .55.45 1 1 1s1-.45 1-1v-2h7.48A2.54 2.54 0 0 1 36 21.54Zm-16.23 4.29c0 .97.78 1.75 1.74 1.75s1.74-.78 1.74-1.75-.78-1.75-1.74-1.75-1.74.78-1.74 1.75M25 30c-.17-1.08-2.38-1.62-3.5-1.62s-3.33.55-3.5 1.62c.07.48.5 1 1 1h5c.5 0 .93-.38 1-.86zm6 0c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1m1-4c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1"/>
</svg>

    );
  }
}
